/**
 * Bandera como emoji, derivada del código ISO 3166-1 alpha-2.
 *
 * Los dos Regional Indicator Symbols correspondientes a las letras: el
 * sistema operativo los dibuja como una bandera. No hay imágenes ni un
 * sprite que mantener, y la lista de países no queda amarrada a un set de
 * archivos que se desactualiza.
 *
 * IMPORTANTE: la bandera nunca va sola. Un lector de pantalla lee "bandera
 * de Costa Rica" en el mejor de los casos y nada en el peor, y a simple
 * vista media docena de tricolores se parecen entre sí. Siempre acompañada
 * del nombre del país, con la bandera marcada aria-hidden.
 */
export function flagEmoji(alpha2: string): string {
  const code = alpha2.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) return '';
  return String.fromCodePoint(...[...code].map((c) => 0x1f1a5 + c.charCodeAt(0)));
}
